import { useCallback } from "react";

const usePointsChange = ({
  api,
  taskId,
  setTask,
  task,
  setShowPointsDropdown,
}) => {
  return useCallback(
    async (pointsValue) => {
      const numericValue = Number(pointsValue);
      if (Number.isNaN(numericValue)) {
        return;
      }

      try {
        await api.task.updateTask(taskId, {
          points_estimate: numericValue,
          version: task.version,
        });
        const updatedTask = await api.task.getTaskById(taskId);
        setTask(updatedTask);
      } catch (error) {
        console.error("Error updating task points:", error);
      } finally {
        setShowPointsDropdown?.(false);
      }
    },
    [api, taskId, setTask, task, setShowPointsDropdown]
  );
};

export default usePointsChange;
